module.exports = __webpack_public_path__ + "img/deal.c0cfe27d.png";